import { addDays, METRIC_TYPE_IDS } from '../../../../domain';
import { SleepReportKeys } from './sleep-report.key';
/** Quantas noites o relatorio mostra: a da celula e as seis anteriores. */
const NIGHTS = 7;
/**
 * O link, ou `undefined` quando o relatorio nao teria o que mostrar.
 *
 * Tres casos sem link: quem esta logado nao entra no relatorio; a pessoa nao tem sono
 * medido; ou quem esta logado ESCOLHE empresa e a pessoa nao tem nenhuma - o relatorio
 * e de um time, e sem empresa ela nao esta entre os atletas que ele oferece.
 */
export function sleepReportLinkOf(app, owner, patient) {
    if (!owner?.allowsSection('sleep-report')) {
        return undefined;
    }
    const night = sleepNightOf(patient);
    if (!night) {
        return undefined;
    }
    const companyId = owner.canChooseCompany ? (patient.companyId ?? undefined) : undefined;
    if (owner.canChooseCompany && companyId === undefined) {
        return undefined;
    }
    /*
     * Sete noites terminando no dia da celula, e nao so ela. O dia da medicao pode ser
     * o de deitar ou o de acordar, e o relatorio poe a noite no dia de deitar; com a
     * semana, a noite esta na tela nos dois casos, e ao lado das que vieram antes.
     */
    const from = addDays(night, -(NIGHTS - 1));
    const to = night;
    return {
        href: app.sealedAddress(SleepReportKeys.plainAddressOf({ patientId: patient.patientId, companyId, from, to })),
        open: async () => {
            const target = SleepReportKeys.of(app);
            target.companyId = companyId;
            target.patientId = patient.patientId;
            target.selectionId = undefined;
            target.period = 'custom';
            target.from = from;
            target.to = to;
            await target.flip();
        }
    };
}
/** O dia (`yyyy-MM-dd`, no fuso de quem olha) do ultimo sono medido, quando ha. */
export function sleepNightOf(patient) {
    const sleep = patient.lastMeasurements?.find((item) => item.measurementTypeId === METRIC_TYPE_IDS.SONO);
    const day = sleep?.date?.slice(0, 10);
    return day && /^\d{4}-\d{2}-\d{2}$/.test(day) ? day : undefined;
}
//# sourceMappingURL=sleep-report.link.js.map